import React from 'react';
import ManagerLayout from '../../components/manager/ManagerLayout';
import { DelegationsManagementPage } from '../shared/DelegationsManagementPage';

const ManagerDelegationsPage: React.FC = () => {
  return (
    <ManagerLayout>
      <DelegationsManagementPage mode="manager" />
    </ManagerLayout>
  );
};

export default ManagerDelegationsPage;
